import { Container } from '@awaze/design-system.components.container';
import { breakpoints, getShadowStyle, } from '@awaze/design-system.utils.react';
import styled from 'styled-components';
export const HeaderExtended = styled.div `
  height: ${(p) => p.isFlush && '34px'};
  padding: 2px 18px 0;
  background-color: ${({ theme, isFlush }) => isFlush && theme.ColorThemeBackgroundHeader};

  background: ${({ theme, isFlush, backgroundColor }) => !isFlush &&
    `linear-gradient(
      to bottom,
      ${theme.ColorThemeBackgroundHeader} 0%,
      ${theme.ColorThemeBackgroundHeader} 50%,
      ${backgroundColor || 'transparent'} 50%,
      ${backgroundColor || 'transparent'} 100%
    )`};

  position: relative;
  z-index: 2;
`;
export const CentralNavigationLink = styled.a `
  ${({ onlyMobile }) => onlyMobile &&
    `
  @media screen and (min-width: ${breakpoints[0]}px) {
    display: none;
  }
  `}

  color: ${({ theme }) => theme.ColorThemeTextHeaderLink};
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
`;
export const ResponsiveHeaderStyled = styled.header `
  padding: 0px 16px;
  background-color: ${({ theme }) => theme.ColorThemeBackgroundHeader};
  justify-content: space-between;
  position: relative;
  height: 72px;
  z-index: 10;
  box-shadow: ${({ shadow, theme }) => shadow ? getShadowStyle({ theme, depth: shadow }) : 'none'};

  svg {
    display: flex;
  }

  ul,
  li {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  // Desktop
  @media (min-width: ${breakpoints[0]}px) {
    height: 80px;
  }
`;
export const ResponsiveHeaderContainer = styled(Container) `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  height: inherit;

  @media screen and (min-width: ${breakpoints[0]}px) {
    gap: 0.75rem;
  }
`;
//# sourceMappingURL=responsive-header.styles.js.map